/**
 * @fileoverview Wallet Service - API client for certificate wallet
 */
import { ApiService } from '@/services/api/apiService';

const api = new ApiService();

class WalletService {
    /**
     * Get all certificates for the authenticated user
     */
    async getCertificates() {
        const response = await api.get('/wallet/certificates');
        return response.data;
    }

    /**
     * Get full certificate details (with decryption)
     * @param {string} certId - Certificate ID
     */
    async getCertificateDetails(certId) {
        const response = await api.get(`/wallet/certificates/${certId}/decrypt`);
        return response.data;
    }

    /**
     * Verify certificate (public, no auth required)
     * @param {string} certId - Certificate ID
     */
    async verifyCertificate(certId) {
        const response = await api.get(`/wallet/certificates/${certId}/verify`);
        return response.data;
    }

    /**
     * Download attachment
     * @param {string} certId - Certificate ID
     * @param {string} filename - Attachment filename
     */
    async downloadAttachment(certId, filename) {
        return api.download(`/wallet/certificates/${certId}/attachment/${filename}`);
    }

    /**
     * Download certificate SVG (Secure)
     * @param {string} certId - Certificate ID
     */
    async downloadCertificate(certId) {
        return api.download(`/wallet/certificates/${certId}/download`);
    }
}

export const walletService = new WalletService();
